<!-- 客服创建售后单消息卡片 -->
<script lang="ts" setup>
import GoodsCardSimple1 from '../../../../common/goods-card/goods-card-simple1.vue';
import { safeJsonParse } from '@/utils/parse';

interface IProps {
    content: {
        ext?: string;
        title?: string;
        type: string;
    };
}

interface ExtObj {
    orderId?: string;
    orderReturnId?: string;
    items?: string;
}

interface GoodsItem {
    goodsId: string;
}

const props = defineProps<IProps>();
const extObj = computed<ExtObj>(() => safeJsonParse(props.content.ext));
const items = computed<GoodsItem[]>(() => safeJsonParse(extObj.value?.items, []));
</script>

<template>
    <div class="flex flex-col w-84 gap-2">
        <div class="line-clamp-2">{{ content.title }}</div>
        <template v-if="Array.isArray(items) && items.length > 0">
            <GoodsCardSimple1
                :data="items[0]"
                :show-num="false"
            >
                <div class="btn hover:cursor-not-allowed">查看详情</div>
            </GoodsCardSimple1>
        </template>
    </div>
</template>

<style lang="scss" scoped>
.btn {
    display: inline-block;
    box-sizing: border-box;
    height: 28px;
    border-radius: 30px;
    background: #e5faff;
    color: #0cf;
    text-align: center;
    font-size: 14px;
    line-height: 28px;
    font-weight: 500;
    padding: 0 16px;
}
</style>
